module.exports = __webpack_public_path__ + "img/MX-C150A-BS-HQ.93a1cfd7.png";